import { useState } from 'react';
import PremiumIcon from '../../assets/premium.png';
import { Alert, AlertActions, AlertDescription, AlertTitle } from '../../catalyst/alert';
import { Button } from '../../catalyst/button';
import { Link } from '../../catalyst/link';
import { Strong, Text } from '../../catalyst/text';
import config from '../../config';

export default function PremiumPopup (props) {
  const [open, setOpen] = useState(props.showPremiumOptions);

  const handleClose = () => {
    setOpen(false)
    props.setShowPremiumOptions(false);
  };

  return (
<>

    <Alert open={open} onClose={() => {props.setShowPremiumOptions(false);}}>
        <AlertTitle>Upgrade Premium</AlertTitle>
        <AlertDescription>
        <img
            src={PremiumIcon} // Replace with your image URL
            alt="Diamond"
            style={{ width: '100px', height: '100px' }}
          />
        <Text>
        You tried to transfer <Strong>{props.triedTracksCount} </Strong>tracks and albums. You can transfer upto <Strong>99</Strong> tracks for free. 
        Go premium just for <Strong>$3.99</Strong> for 30 days
        </Text>
        <Strong>no subscription</Strong>
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={() => handleClose}>
            Cancel
          </Button>
          <Link href={config.premiumPath}><Button onClick={() => {}}>Go Premium for $3.99 !!</Button></Link>
        </AlertActions>
      </Alert>
    </>


  );
};
